import * as moment from 'moment';
import { Observable } from 'rxjs';
import { ProductModel } from '../product/model/product.model';
import { AssetSearchModel } from './components/model/asset-search.model';
import { AssetModel } from './components/model/asset.model';
import { AssetService } from './service/asset.service';

export class AssetHelper {
  /**
   * Builds up the asset search query string.
   * @param {AssetSearchModel} assetSearchModel
   * @returns {string}
   */
  public static getAssetSearchQueryString(
    assetSearchModel: AssetSearchModel
  ): string {
    let query = '';
    for (let p in assetSearchModel.filterModel) {
      if (
        assetSearchModel.filterModel.hasOwnProperty(p) &&
        assetSearchModel.filterModel[p] !== null &&
        assetSearchModel.filterModel[p] !== '' &&
        p !== 'makeId'
      ) {
        query +=
          p + '=' + assetSearchModel.filterModel[p].toString().trim() + '&';
      }
    }
    query = `?${query}pageNumber=${assetSearchModel.pageNumber}&pageSize=${
      assetSearchModel.pageSize ? assetSearchModel.pageSize : '100'
    }`;

    return query;
  }
  /**
   *  Generic method to Add no. of days to the date
   */
  protected static addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  /**
   *  Gets all the collected data from the endpoints:
   *      '../console/api/sync/asset',
   *      '../console/api/sync/site/SiteId',
   *      '../console/api/sync/make/MakeId' '
   * @param {number} assetId
   * @param assetService
   * @returns {Observable<any>}
   */
  public static getAssetDetails(
    assetId: number,
    assetService: AssetService
  ): Observable<any> {
    // Create the Initial Chain of Object
    let observablesAssetChainInfo = Observable.forkJoin([
      /* [0] */ assetService.getAssetById(assetId)
    ]);

    // Internal Variable declaration.
    let assetModel = new AssetModel();
    let assetSiteRequest = [];

    // Execute the Fork Join to get each value, the index on the Join should match response index
    let firstAssetChainInfo = Observable.from(observablesAssetChainInfo).map(
      (res: any) => {
        // Getting Mapped Asset Model
        if (res[0]) {
          assetModel = res[0];
          assetModel.productId = res[0].machineProductId;
          const installDate = moment(
            assetModel.installDate,
            'YYYY-MM-DDT'
          ).toDate();
          assetModel.installDate = res[0].installDate ? installDate : null;
          const manufacturedDate = moment(
            assetModel.manufacturedDate,
            'YYYY-MM-DDT'
          ).toDate();
          assetModel.manufacturedDate = res[0].manufacturedDate
            ? manufacturedDate
            : null;
        }
        return assetModel;
      }
    );

    // Subscribe the Result (FlatMap executes an inner subscription)
    let siteRequests = firstAssetChainInfo.flatMap((res: any) => {
      assetModel = res;
      assetSiteRequest.push(
        assetService.getSiteById(assetModel.siteId)
      ); /* [0] */
      assetSiteRequest.push(
        assetService.getAssetProduct(assetModel.productId)
      ); /* [1] */
      return Observable.forkJoin(assetSiteRequest);
    });

    // Execute the inner Fork Join, index should match the original Join from Site Request
    let secondAssetChainInfo = Observable.from(siteRequests).map((res: any) => {
      if (res[0]) {
        /* assetService.getSiteById */
        assetModel.site = res[0];
      }
      assetModel.product = new ProductModel();
      if (res[1]) {
        /* assetService.getAssetProduct */
        assetModel.product = res[1];
      }
      return assetModel;
    });

    // Subscribe the Result (FlatMap executes an inner subscription)
    let makeRequests = secondAssetChainInfo.flatMap((res: AssetModel) => {
      assetModel = res;
      assetSiteRequest.push(
        assetService.getMakeById(assetModel.product.makeId)
      ); /* [2] */
      assetSiteRequest.push(
        assetService.getAssetType(
          assetModel.product.assetTypeId ? assetModel.product.assetTypeId : 0
        )
      ); /* [3] */
      return Observable.forkJoin(assetSiteRequest);
    });

    // Execute the inner Fork Join, index should match the original Join from Make Request
    return Observable.from(makeRequests).map((res: any) => {
      if (res[2]) {
        /* assetService.getMakeById */
        assetModel.make = res[2];
      }
      assetModel.product.assetType = null;
      if (res[3]) {
        /* assetService.getAssetTypeById */
        assetModel.product.assetType = res[3];
      }
      return assetModel;
    });
  }
}
